// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"20c4b9d7","505":"9285c446","540":"cf159760","879":"53becd03"}[chunkId] + ".chunk.js";
};